import { createSlice } from '@reduxjs/toolkit';
// Initial state
const initialState = {
    messages: {},
};
// Create a slice for handling NATS messages
export const natsSlice = createSlice({
    name: 'nats',
    initialState,
    reducers: {
        updateMessage: (state, action) => {
            const { subject, payload } = action.payload;
            state.messages[subject] = payload;
        },
        // Batched variant used when many subjects are hydrated at once (e.g. the
        // initial snapshot for a floor with hundreds of desks). Applying them in a
        // single action means a single store notification / re-render instead of one
        // per subject.
        updateMessages: (state, action) => {
            for (const { subject, payload } of action.payload) {
                state.messages[subject] = payload;
            }
        },
    },
});
// Export actions
export const { updateMessage, updateMessages } = natsSlice.actions;
